import React, { useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { sadSmiley } from 'assets/images';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { logoSvg } from 'assets/images';
import { useFormContext } from 'react-hook-form';

const Step6: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  const { getValues } = useFormContext();

  const credit_score_error_heading = getValues('credit_score_error_heading') ?? t('stepperFormCredit.errorMsg');
  const credit_score_error_desc = getValues('credit_score_error_desc');

  // React Hook Form Trigger
  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;
    onNext?.();
  };

  const backStep = () => {
    onBack?.(2);
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <div className='csc-screens__form-col'>
      <div className='logo'>
        <img src={logoSvg} alt='Dabadu' className='img-fluid' />
      </div>
      <div className='csc-screens__form-col__middle'>
        <div className='csc-error-screen'>
          <div className='csc-error-screen__sad-icon'>
            <img src={sadSmiley} alt='sad' className='img-fluid'></img>
          </div>
          <h3 className='csc-screens__form-col__title text-center'>{credit_score_error_heading}</h3>
          <div className='csc-error-screen__content'>
            <p>
              <strong>{credit_score_error_desc}</strong>
            </p>
            {/* <ul>
              <li>
                <span>{softAssesmentData?.errorMessage}</span>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const StepperForm6 = React.forwardRef(Step6);

export default StepperForm6;
